<script lang="ts">
	import Pin from 'components/search/Pin.svelte'
	import Input from '@isoftdata/svelte-input'
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')

	interface Props {
		to?: string
		from?: string
		label?: string
		disabled?: boolean
		isPinned?: boolean
		id?: string
		change?: (value: { from: string; to: string }) => void
	}

	let {
		to = $bindable(''),
		from = $bindable(''),
		label = '',
		disabled = false,
		isPinned = false,
		id = '',
		change,
	}: Props = $props()
</script>

<label
	for={id}
	class="col-form-label pb-0"
	>{label} <Pin {isPinned} />
</label>
<div class="form-row">
	<div class="col-12 col-md-6">
		<Input
			{id}
			label={translate('common:from', 'From')}
			{disabled}
			bind:value={from}
			onchange={() => {
				if (from && !to) {
					to = from
				}
				change?.({ from, to })
			}}
		/>
	</div>

	<div class="col-12 col-md-6">
		<Input
			label={translate('common:to', 'To')}
			{disabled}
			bind:value={to}
			onchange={() => change?.({ from, to })}
		/>
	</div>
</div>
